<template>
  <div class="modal">
    <router-link to="/" class="modal__overlay" />
    <div class="modal__inner">
      <div class="modal__header">
        <h1 class="logo--modal">One Day.</h1>
        <router-link to="/" class="modal__close">
          <svg class="svg-icon" viewBox="0 0 20 20">
            <path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
          </svg>
        </router-link>
      </div>
      <iframe :src="`https://player.vimeo.com/video/${l10n[$route.query.lang].films.list[$route.query.id].video_id}`" width="960" height="540" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

      <div class="modal__header">
        <p class="intro__sub--modal">{{ l10n[$route.query.lang].intro.series }}</p>
        <p class="modal__sponsor" v-html="l10n[$route.query.lang].intro.sponsor"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: [ 'l10n' ]
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue